import react from 'react';
import { OrderDetails, LineItemOrderDetails } from '../../../utils/kit/modules/paymentProcessing';
import { formatCurrencyValue } from '../../../utils/currency';
import LineItemReadOnlyDisplay from '../../LineItems/LineItemReadOnlyDisplay';
import { useNavigate } from 'react-router';

interface CheckoutCompletedProps {
    order: OrderDetails,
    orderId: string,
    eventIds: number[]
}

const CheckoutCompleted = (props: CheckoutCompletedProps) =>
{
    const navigate = useNavigate();
    //TODO: Pull Currency from order
    const currency = {
        name: 'USD',
        localization: Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD'
        }),
        formatting: {
            prefix: '$',
            suffix: '',
            decimalSeparator: '.',
            groupSeparator: ',',
            decimalLimit: 2
        }
    }
    
    const renderOrderItems = (lineItems: LineItemOrderDetails[]) =>
    {
        return lineItems.map((lineItem) => 
        {
            return(<LineItemReadOnlyDisplay lineItem={lineItem} />)
        })
    }

    const renderRedirectButtons = (events: number[]) => 
    {
        return events.map((event) => 
        {
            if (event != 0)
            {
                const stringID = event.toString();
                return(<div>
                    <button className="buttonPrimary" onClick={() => navigate('/events/eventpage/' + stringID)}>Event Page</button>
                    <button className="buttonPrimary" onClick={() => navigate('/events/eventpage/calendar/' + stringID)}>Session Scheduler</button>
                </div>)
            }
            return (<div></div>)
        })
    }

    return(
        <div className='checkoutThankYou'>
            <b>Thank you for your order</b>
            <p>Your order id is {props.orderId}</p>
            {renderRedirectButtons(props.eventIds)}
            <div className='checkoutLineItemList'>
                <hr></hr>
                {renderOrderItems(props.order.lineItems)}
                <p>Total Cost: {formatCurrencyValue(props.order.totalCost, currency.formatting).formatted}</p>
            </div>
        </div>
    )
}

export default CheckoutCompleted